/* eslint-disable vue/require-v-for-key */
<template>
  <v-card>
    <v-form ref="form" v-model="isFormValid" lazy-validation>
      <v-card-text>
        <v-container>
          <!-- <v-row>
            <v-select
              v-if="selectedIndex !== -1"
              v-model="selectedItem.lotes"
              :items="lotes"
              item-text="lote"
              item-value="id"
              label="Lotes"
              v-on:change="changeTokens(selectedItem.lotes)"
            ></v-select>
          </v-row>
          <v-row>
            <v-expansion-panels accordion v-if="selectedIndex !== -1">
              <v-expansion-panel>
                <v-expansion-panel-header
                  >Tokens ({{ tokens.length }})</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <ul id="tokens">
                    <li v-for="token in tokens" :key="token">
                      {{ token }}
                    </li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row> -->
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="selectedItem.nameToken"
                label="Nome do Token"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-textarea
                v-model="selectedItem.description"
                :counter="250"
                :rules="formRules.descriptionRules"
                label="Descrição Completa"
                required
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select
                v-model="selectedItem.category"
                :items="categories"
                item-text="category"
                item-value="id"
                label="Categoria"
                persistent-hint
                return-object
                single-line
                multiple
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select
                v-model="selectedItem.subcategories"
                :items="subcategoriesList"
                item-text="subcategory"
                item-value="id"
                label="Subcategorias / Tags"
                persistent-hint
                return-object
                single-line
                chips
                multiple
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-select
                v-model="selectedItem.unidades"
                :items="unidades"
                item-text="unid"
                item-value="id"
                label="Unidades de medida do token"
                return-object
              ></v-select>
            </v-col>

            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-if="
                  selectedItem.unidades
                    ? selectedItem.unidades.id == 7 ||
                      selectedItem.unidades == 'Outros'
                      ? true
                      : false
                    : false
                "
                v-model="selectedItem.otherUnid"
                label="Outros"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="selectedItem.complement"
                label="Complemento"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-if="selectedItem.unidades"
                v-model="selectedItem.valorunidade"
                :label="
                  'Qtde de cada unidade ( ' + selectedItem.unidades.unid + ' )'
                "
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-file-input
                v-model="selectedItem.photo"
                hide-details="auto"
                label="Logo do Token disponível para visualização dos Usuários"
                prepend-icon="mdi-camera"
                accept="image/*"
                show-size
                small-chips
                @change="selectedNewLogoToken"
              ></v-file-input>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-file-input
                v-model="selectedItem.files"
                hide-details="auto"
                label="Arquivos disponíveis para visualização dos Usuários"
                prepend-icon="mdi-camera"
                multiple
                show-size
                counter
                small-chips
                truncate-length="25"
              ></v-file-input>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <table
                v-for="(file, index) in filesActives"
                :key="file.id"
                :style="{ marginBottom: '20px' }"
              >
                <tr>
                  <th>Visualizar</th>
                  <th>Excluir</th>
                </tr>
                <tr>
                  <td
                    :style="{ width: '206px !important', textAlign: 'center' }"
                  >
                    <a
                      :href="
                        'https://filesgpx.s3.us-east-2.amazonaws.com/' +
                        file.path
                      "
                      download
                      target="_blank"
                    >
                      {{ file.name }}
                    </a>
                  </td>
                  <td>
                    <v-row
                      align="center"
                      justify="center"
                      :style="{ cursor: 'pointer' }"
                      @click="deleteFile(index, file.path)"
                    >
                      <v-icon color="red"> mdi-delete </v-icon>
                    </v-row>
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="selectedItem.apiIndex"
                label="API índice"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="selectedItem.deadlineToken"
                label="Data limite"
                :rules="formRules.dataRules"
                type="date"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select
                v-model.lazy="typeValue"
                :items="itemsValueType"
                item-text="type"
                item-value="id"
                label="Tipo do valor"
                persistent-hint
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row v-if="fixedValue">
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="selectedItem.singleValue"
                label="Valor único"
                required
                hide-details="auto"
                prefix="R$"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>

          <div v-if="variableValue">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="selectedItem.minValueToken"
                  label="Valor minimo por Token"
                  required
                  hide-details="auto"
                  prefix="R$"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="selectedItem.totalValueToken"
                  label="Valor total do ativo"
                  required
                  hide-details="auto"
                  prefix="R$"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-checkbox
                v-model="checkbox"
                :label="`Limitar Ativo por Quantidade máxima de tokens?`"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row v-if="checkbox">
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="selectedItem.amountToken"
                label="Quantidade máxima de tokens"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select
                v-model="selectedItem.cryptoactive"
                :items="itemsCryptoactive"
                item-text="type"
                item-value="bool"
                label="É um criptoativo?"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select
                v-model="selectedItem.certificate"
                :items="itemsCertificate"
                item-text="type"
                item-value="bool"
                label="Emite certificado?"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model="selectedItem.feezeroMk"
                label="Número casas decimais"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feeMk"
                label="Taxa Marketplace"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.currencyMk"
                :items="itemsCurrency"
                item-text="type"
                item-value="bool"
                label="Moeda de Taxa"
                return-object
              ></v-select>
            </v-col>
            <!-- <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feezeroMk"
                label="Número casas decimais"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col> -->
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.typeFeeMk"
                :items="itemsTypefee"
                item-text="type"
                item-value="bool"
                label="Tipo de taxa"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feeExBuy"
                label="Taxa Compra Exchange"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.currencyExBuy"
                :items="itemsCurrency"
                item-text="type"
                item-value="bool"
                label="Moeda de Taxa"
                return-object
              ></v-select>
            </v-col>
            <!-- <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feezeroExBuy"
                label="Número casas decimais"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col> -->
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.typeFeeExBuy"
                :items="itemsTypefee"
                item-text="type"
                item-value="bool"
                label="Tipo de taxa"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feeExShell"
                label="Taxa Venda Exchange"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.currencyExShell"
                :items="itemsCurrency"
                item-text="type"
                item-value="bool"
                label="Moeda de Taxa"
                return-object
              ></v-select>
            </v-col>
            <!-- <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feezeroExShell"
                label="Número casas decimais"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col> -->
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.typeFeeExShell"
                :items="itemsTypefee"
                item-text="type"
                item-value="bool"
                label="Tipo de taxa"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feeTx"
                label="Taxa de Transferência"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.currencyTx"
                :items="itemsCurrency"
                item-text="type"
                item-value="bool"
                label="Moeda de Taxa"
                return-object
              ></v-select>
            </v-col>
            <!-- <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feezeroTx"
                label="Número casas decimais"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col> -->
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.typeFeeTx"
                :items="itemsTypefee"
                item-text="type"
                item-value="bool"
                label="Tipo de taxa"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row
            v-if="
              typeof selectedItem.cryptoactive != 'object'
                ? selectedItem.cryptoactive
                : selectedItem.cryptoactive
                ? selectedItem.cryptoactive.bool
                : false
            "
          >
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feeDp"
                label="Taxa de Depósito"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.currencyDp"
                :items="itemsCurrency"
                item-text="type"
                item-value="bool"
                label="Moeda de Taxa"
                return-object
              ></v-select>
            </v-col>
            <!-- <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feezeroDp"
                label="Número casas decimais"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col> -->
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.typeFeeDp"
                :items="itemsTypefee"
                item-text="type"
                item-value="bool"
                label="Tipo de taxa"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row
            v-if="
              typeof selectedItem.cryptoactive != 'object'
                ? selectedItem.cryptoactive
                : selectedItem.cryptoactive
                ? selectedItem.cryptoactive.bool
                : false
            "
          >
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feeSk"
                label="Taxa de Saque"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.currencySk"
                :items="itemsCurrency"
                item-text="type"
                item-value="bool"
                label="Moeda de Taxa"
                return-object
              ></v-select>
            </v-col>
            <!-- <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feezeroSk"
                label="Número casas decimais"
                required
                hide-details="auto"
                type="number"
              ></v-text-field> 
            </v-col>-->
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.typeFeeSk"
                :items="itemsTypefee"
                item-text="type"
                item-value="bool"
                label="Tipo de taxa"
                return-object
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#0dc4b8" text @click="$emit('onClose')"> Cancelar </v-btn>
        <v-btn
          color="#0dc4b8"
          text
          @click="submit"
          :disabled="isLoading"
          :loading="isLoading"
        >
          {{ formButtonText }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>


<script>
import { mapMutations } from "vuex";
import ClientsService from "../../services/clients.service";
import Api from "../../services/api.service";

export default {
  name: "AssetsForm",
  props: {
    selectedIndex: {
      type: Number,
      required: false,
      default: -1,
    },
    selectedData: Array,
    filesActivesProps: Array,
  },
  data: () => ({
    tokens: [],
    tokensGeral: [],
    lotes: [],
    checkbox: false,
    clientSearch: null,
    categories: [],
    clientOptions: [],
    dialog: false,
    unidades: [
      { id: 1, unid: "ton" },
      { id: 2, unid: "kg" },
      { id: 3, unid: "g" },
      { id: 4, unid: "lt" },
      { id: 5, unid: "m2" },
      { id: 6, unid: "Und" },
      // { id: 7, unid: "Outros" },
    ],
    itemsCryptoactive: [
      { type: "Sim", bool: true },
      { type: "Não", bool: false },
    ],
    itemsCertificate: [
      { type: "Sim", bool: true },
      { type: "Não", bool: false },
    ],
    itemsValueType: [
      { type: "Valor Fixo", id: 1 },
      { type: "Valor Variável", id: 2 },
    ],
    itemsCurrency: [
      { type: "Próprio ativo", bool: true },
      { type: "GPX", bool: false },
    ],
    itemsTypefee: [
      { type: "Valor Fixo", bool: true },
      { type: "Valor Variável (%)", bool: false },
    ],
    files: [],
    formRules: {
      clientRules: [(v) => !!v || "Cliente é obrigatório"],
      codeRules: [(v) => !!v || "Código é obrigatório"],
      dataRules: [(v) => !!v || "Data é obrigatório"],
      descriptionRules: [
        (v) => !!v || "Descrição é obrigatória",
        (v) =>
          (v || "").length <= 250 ||
          "A descrição deve ter 250 caracteres ou menos",
      ],
      filesRules: [
        (v) =>
          !!v || v.size < 2000000 || "Documento deve ser menor do que 2 MB!",
      ],
      photosRules: [
        (v) => !!v || v.size < 2000000 || "Foto deve ser menor do que 2 MB!",
      ],
    },
    isFormValid: true,
    isLoading: false,
    photos: [],
    newLogoToken: 0,
    selectedItem: {
      otherUnid: null,
      complement: null,
      nameToken: null,
      description: null,
      photo: null,
      category: null,
      minValueToken: null,
      totalValueToken: null,
      singleValue: null,
      amountToken: null,
      valueType: null,
      cryptoactive: null,
      certificate: null,
      deadlineToken: null,
      lotes: 1,
      files: [],
      feeMk: null,
      feezeroMk: null,
      typeFeeMk: null,
      currencyMk: null,
      feeSk: null,
      feezeroSk: null,
      typeFeeSk: null,
      currencySk: null,
      feeTx: null,
      feezeroTx: null,
      typeFeeTx: null,
      currencyTx: null,
      feeExBuy: null,
      feezeroExBuy: null,
      typeFeeExBuy: null,
      currencyExBuy: null,
      feeExShell: null,
      feezeroExShell: null,
      typeFeeExShell: null,
      currencyExShell: null,
      feeDp: null,
      feezeroDp: null,
      typeFeeDp: null,
      currencyDp: null,
      unidades: null,
      subcategories: null
    },
    fixedValue: false,
    variableValue: false,
    typeValue: null,
    filesActives: [],
    filesDelete: [],
    subcategoriesList: []
  }),
  computed: {
    formButtonText() {
      return this.selectedIndex === -1 ? "Criar" : "Editar";
    },
  },
  watch: {
    clientSearch(val) {
      if (!this.selectedItem.client_id) val && this.loadClientData(val);
    },

    typeValue: function (value) {
      this.selectedItem.valueType = value.type;

      if (value.id === 1) {
        this.fixedValue = true;
        this.variableValue = false;

        this.selectedItem.minValueToken = null;
        this.selectedItem.totalValueToken = null;
      } else {
        this.fixedValue = false;
        this.variableValue = true;

        this.selectedItem.singleValue = null;
      }
    },
  },
  mounted() {
    this.fakeTokensGrid();
    this.loadCategories();

    if (this.selectedIndex === -1) this.limpaForm();
   // if (this.selectedIndex !== -1) this.loadTokensGenerate();

    console.log(this.selectedItem);
    if (this.selectedIndex !== -1) {
      setTimeout(() => {
        var type = this.selectedData.type_value === "Valor Fixo" ? 1 : 2;

        this.typeValueMounted(type);
        this.typeValue = { id: type, type: this.selectedData.type_value };
        //this.selectedItem.valueType = this.selectedData.type_value;

        var categorys = [];
        this.selectedData.arrayDuplicate.map((e) => {
          if (!categorys.includes(e.category)) categorys.push(e.category);
        });
        // this.selectedItem.category = this.selectedData.category;

        this.selectedItem.category = categorys;

        this.selectedItem.subcategories = this.selectedData.subcategories;

        this.selectedItem.nameToken = this.selectedData.name_token;
        this.selectedItem.description = this.selectedData.description;

        this.selectedItem.amountToken = this.selectedData.amount_token;
        this.selectedItem.cryptoactive = this.selectedData.cryptoactive;
        this.selectedItem.certificate = this.selectedData.certificate;
        this.selectedItem.deadlineToken = this.selectedData.deadline_token;

        this.selectedItem.unidades = this.selectedData.unidades;
        this.selectedItem.otherUnid = this.selectedData.otherUnid;
        this.selectedItem.complement = this.selectedData.complement;
        this.checkbox = this.selectedData.checkbox;
        this.selectedItem.valorunidade = this.selectedData.valorunidade;

        this.unidades.map((e) => {
          if (e.unid == this.selectedData.unidades)
            this.selectedItem.unidades = e;
        });

        //fee
        this.selectedItem.feeMk = this.selectedData.feeMk;
        this.selectedItem.currencyMk = this.selectedData.currencyMk;
        this.selectedItem.typeFeeMk = this.selectedData.typeFeeMk;
        this.selectedItem.feezeroMk = this.selectedData.feezeroMk;
        this.selectedItem.feeSk = this.selectedData.feeSk;
        this.selectedItem.currencySk = this.selectedData.currencySk;
        this.selectedItem.typeFeeSk = this.selectedData.typeFeeSk;
        this.selectedItem.feezeroSk = this.selectedData.feezeroSk;
        this.selectedItem.feeTx = this.selectedData.feeTx;
        this.selectedItem.currencyTx = this.selectedData.currencyTx;
        this.selectedItem.typeFeeTx = this.selectedData.typeFeeTx;
        this.selectedItem.feezeroTx = this.selectedData.feezeroTx;
        this.selectedItem.feeExBuy = this.selectedData.feeExBuy;
        this.selectedItem.currencyExBuy = this.selectedData.currencyExBuy;
        this.selectedItem.typeFeeExBuy = this.selectedData.typeFeeExBuy;
        this.selectedItem.feezeroExBuy = this.selectedData.feezeroExBuy;
        this.selectedItem.feeExShell = this.selectedData.feeExShell;
        this.selectedItem.currencyExShell = this.selectedData.currencyExShell;
        this.selectedItem.typeFeeExShell = this.selectedData.typeFeeExShell;
        this.selectedItem.feezeroExShell = this.selectedData.feezeroExShell;
        this.selectedItem.feeDp = this.selectedData.feeDp;
        this.selectedItem.currencyDp = this.selectedData.currencyDp;
        this.selectedItem.typeFeeDp = this.selectedData.typeFeeDp;
        this.selectedItem.feezeroDp = this.selectedData.feezeroDp;
        setTimeout(() => {
          if (type === 1) {
            this.fixedValue = true;
            this.variableValue = false;
          } else {
            this.fixedValue = false;
            this.variableValue = true;
          }

          this.selectedItem.minValueToken = this.selectedData.min_value_token;
          this.selectedItem.totalValueToken =
            this.selectedData.total_value_token;
          this.selectedItem.singleValue = this.selectedData.single_value;
        }, 100);

        this.selectedItem.photo = new File(
          [
            "https://filesgpx.s3.us-east-2.amazonaws.com/" +
              this.selectedData.path,
          ],
          this.selectedData.name,
          {
            type: this.selectedData.mime_type,
          }
        );

        var files = [];

        this.filesActivesProps.map((item) => {
          files.push(
            new File(
              ["https://filesgpx.s3.us-east-2.amazonaws.com/" + item.path],
              item.name,
              {
                type: item.mime_type,
              }
            )
          );
        });

        this.selectedItem.files = [];

        this.filesActives = this.filesActivesProps;
      }, 10);
    }
  },
  methods: {
    limpaForm() {
      this.selectedItem = {
        nameToken: null,
        description: null,
        photo: null,
        category: null,
        minValueToken: null,
        totalValueToken: null,
        singleValue: null,
        amountToken: null,
        valueType: null,
        cryptoactive: null,
        certificate: null,
        deadlineToken: null,
        lotes: 1,
        files: [],
      };
    },
    fakeTokensGrid() {
      let letters = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ];
      let z = 1;
      for (let i = 0, j = 0; j < 100; i++, j++) {
        if (i >= letters.length) {
          i = 0;
          z++;
        }
        this.tokens.push(letters[i] + z);
      }
    },
    ...mapMutations(["showSnackbar"]),

    openDialog() {
      this.dialog = true;
    },

    closeDialog() {
      // this.closeFormModal();

      this.typeValue = null;
      this.selectedItem.nameToken = null;
      this.selectedItem.description = null;
      this.selectedItem.category = null;
      this.selectedItem.amountToken = null;
      this.selectedItem.cryptoactive = null;
      this.selectedItem.certificate = null;
      this.selectedItem.deadlineToken = null;
      this.fixedValue = false;
      this.variableValue = false;
      this.selectedItem.minValueToken = null;
      this.selectedItem.totalValueToken = null;
      this.selectedItem.singleValue = null;
      this.selectedItem.photo = null;
      this.selectedItem.files = [];

      this.filesActives = null;

      this.newLogoToken = 0;

      this.$emit("onClose");
    },

    deleteFile(file, path) {
      this.filesDelete.push(path);
      this.filesActives.splice(file, 1);
    },

    typeValueMounted(value) {
      this.selectedItem.valueType = value;

      if (value === 1) {
        this.fixedValue = true;
        this.variableValue = false;
      } else {
        this.fixedValue = false;
        this.variableValue = true;
      }
    },

    convertBase64: function (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    selectedNewLogoToken() {
      this.newLogoToken = 1;
    },

    async handleFiles() {
      this.selectedItem.files = [];

      for (let i = 0; i < this.files.length; i++)
        this.selectedItem.files.push({
          name: this.files[i].name,
          data: await this.convertBase64(this.files[i]),
        });
    },

    async handlePhotos() {
      this.selectedItem.photos = [];

      for (let i = 0; i < this.photos.length; i++)
        this.selectedItem.photos.push({
          name: this.photos[i].name,
          data: await this.convertBase64(this.photos[i]),
        });
    },

    loadClientData(query) {
      if (query.length >= 3) {
        this.isLoading = true;

        const params = {
          "filter[nameOrEmail]": query,
        };

        ClientsService.get(params)
          .then(({ data }) => {
            const { data: items } = data;
            this.clientOptions = items;
          })
          .catch(() => {
            this.showSnackbar({
              text: "Ops! Ocorreu um erro inesperado",
              color: "error",
            });
          })
          .finally(() => setTimeout(() => (this.isLoading = false), 300));
      }
    },

    loadCategories() {
      Api.get("categories")
        .then((res) => {
          var arrayCategory = [];

          res.data[0].map((item) => {
            arrayCategory.push({
              id: item.id,
              category: item.name,
            });
          });

          this.categories = arrayCategory;
        })
        .catch(() => {
          this.showSnackbar({
            text: "Ops!, Houve um erro ao carregar as categorias, tente novamente mais tarde.",
            color: "error",
          });
        });
      
      Api.get("subcategories")
        .then((res) => {
          var arraySubcategory = [];

          res.data[0].map((item) => {
            arraySubcategory.push({
              id: item.id,
              subcategory: item.name,
            });
          });

          this.subcategoriesList = arraySubcategory;
        })
        .catch(() => {
          this.showSnackbar({
            text: "Ops!, Houve um erro ao carregar as subcategorias, tente novamente mais tarde.",
            color: "error",
          });
        });
    },

    loadTokensGenerate() {
      Api.get(`generation-tokens/${this.selectedIndex}`)
        .then((res) => {
          res.data.lotes.map((item) => {
            this.lotes.push(item.lote);
          });
          this.tokensGeral = res.data.tokens;
          this.tokens = [];
          res.data.tokens.map((item) => {
            if (item.lote == 1) this.tokens.push(item.name);
          });
        })
        .catch(() => {
          this.showSnackbar({
            text: "Ops!, Houve um erro ao carregar as categorias, tente novamente mais tarde.",
            color: "error",
          });
        });
    },

    async changeTokens(a) {
      this.tokens = [];
      this.tokensGeral.map((item) => {
        if (item.lote == a) this.tokens.push(item.name);
      });
    },

    async validate() {
      console.log(!this.selectedItem.feeMk);
      console.log(this.selectedItem.currencyMk === null);
      console.log(this.selectedItem.typeFeeMk === null);
      console.log(!this.selectedItem.feezeroMk);
      console.log(!this.selectedItem.feeTx);
      console.log(this.selectedItem.currencyTx === null);
      console.log(this.selectedItem.typeFeeTx === null);
      console.log(!this.selectedItem.feeExBuy);
      console.log(this.selectedItem.currencyExBuy === null);
      console.log(this.selectedItem.typeFeeExBuy === null);
      console.log(!this.selectedItem.feeExShell);
      console.log(this.selectedItem.currencyExShell === null);
      console.log(this.selectedItem.typeFeeExShell === null);
      if (
        !this.selectedItem.feeMk ||
        this.selectedItem.currencyMk === null ||
        this.selectedItem.typeFeeMk === null ||
        (!this.selectedItem.feezeroMk && (this.selectedItem.feezeroMk !== 0)) ||
        // !this.selectedItem.feeSk ||
        // this.selectedItem.currencySk === null||
        // this.selectedItem.typeFeeSk === null||
        // !this.selectedItem.feezeroSk ||
        
        this.selectedItem.currencyTx === null ||
        this.selectedItem.typeFeeTx === null ||
        // !this.selectedItem.feezeroTx ||
        
        this.selectedItem.currencyExBuy === null ||
        this.selectedItem.typeFeeExBuy === null ||
        // !this.selectedItem.feezeroExBuy ||
        this.selectedItem.currencyExShell === null ||
        this.selectedItem.typeFeeExShell === null 
        // !this.selectedItem.feezeroExShell
        // !this.selectedItem.feeDp ||
        // this.selectedItem.currencyDp === null ||
        // this.selectedItem.typeFeeDp === null ||
        // !this.selectedItem.feezeroDp
      ) {
        this.showSnackbar({
          text: "Ops! Preencha todas as taxas obrigatórias.",
          color: "error",
        });
        this.isLoading = false;
        return false;
      }

      if (this.selectedItem.description.length > 250) {
        this.showSnackbar({
          text: "A descrição deve ter 250 caracteres ou menos.",
          color: "error",
        });
        this.isLoading = false;
        return false;
      }
      if (!this.selectedItem.deadlineToken) {
        this.showSnackbar({
          text: "A data limite é obrigatória.",
          color: "error",
        });
        this.isLoading = false;
        return false;
      }

      if (!this.selectedItem.description) {
        this.showSnackbar({
          text: "Preencha a descrição da categoria para continuar.",
          color: "error",
        });
        this.isLoading = false;
        return false;
      }
      return true;
    },

    async submit() {
      this.isLoading = true;
      this.selectedItem.client_id = localStorage.getItem("auth.user_id");
      if (await this.validate())
        if (this.selectedIndex === -1) {
          this.selectedItem.category.map((e) => {
            let data = new FormData();

            data.append("nameToken", this.selectedItem.nameToken);
            data.append("description", this.selectedItem.description);
            data.append("category", e.id);
            data.append("photo", this.selectedItem.photo);
            data.append("minValueToken", this.selectedItem.minValueToken);
            data.append("totalValueToken", this.selectedItem.totalValueToken);
            data.append("amountToken", this.selectedItem.amountToken);
            data.append("cryptoactive", this.selectedItem.cryptoactive.bool);
            data.append("certificate", this.selectedItem.certificate.bool);
            data.append("deadlineToken", this.selectedItem.deadlineToken);
            data.append("singleValue", this.selectedItem.singleValue);
            data.append("typeValue", this.selectedItem.valueType);
            data.append("otherUnid", this.selectedItem.otherUnid);
            data.append("complement", this.selectedItem.complement);
            data.append("checkbox", this.checkbox);
            data.append("unidades", this.selectedItem.unidades.unid);
            data.append("valorunidade", this.selectedItem.valorunidade);
            if(this.selectedItem?.subcategories?.length > 0) {
              data.append("subcategories", JSON.stringify(this.selectedItem.subcategories.map((el) => el.id)));
            }else{
              data.append("subcategories", "[]");
            }

            //Fee
            data.append("feeMk", this.selectedItem.feeMk);
            data.append(
              "currencyMk",
              typeof this.selectedItem.currencyMk == "boolean"
                ? this.selectedItem.currencyMk
                : this.selectedItem.currencyMk.bool
            );
            data.append(
              "typeFeeMk",
              typeof this.selectedItem.typeFeeMk == "boolean"
                ? this.selectedItem.typeFeeMk
                : this.selectedItem.typeFeeMk.bool
            );
            data.append("feezeroMk", this.selectedItem.feezeroMk);

            data.append("feeTx", this.selectedItem.feeTx);
            data.append(
              "currencyTx",
              typeof this.selectedItem.currencyTx == "boolean"
                ? this.selectedItem.currencyTx
                : this.selectedItem.currencyTx.bool
            );
            data.append(
              "typeFeeTx",
              typeof this.selectedItem.typeFeeTx == "boolean"
                ? this.selectedItem.typeFeeTx
                : this.selectedItem.typeFeeTx.bool
            );
           // data.append("feezeroTx", this.selectedItem.feezeroTx);

            data.append("feeExBuy", this.selectedItem.feeExBuy);
            data.append(
              "currencyExBuy",
              typeof this.selectedItem.currencyExBuy == "boolean"
                ? this.selectedItem.currencyExBuy
                : this.selectedItem.currencyExBuy.bool
            );
            data.append(
              "typeFeeExBuy",
              typeof this.selectedItem.typeFeeExBuy == "boolean"
                ? this.selectedItem.typeFeeExBuy
                : this.selectedItem.typeFeeExBuy.bool
            );
          //  data.append("feezeroExBuy", this.selectedItem.feezeroExBuy);

            data.append("feeExShell", this.selectedItem.feeExShell);
            data.append(
              "currencyExShell",
              typeof this.selectedItem.currencyExShell == "boolean"
                ? this.selectedItem.currencyExShell
                : this.selectedItem.currencyExShell.bool
            );
            data.append(
              "typeFeeExShell",
              typeof this.selectedItem.typeFeeExShell == "boolean"
                ? this.selectedItem.typeFeeExShell
                : this.selectedItem.typeFeeExShell.bool
            );
          //  data.append("feezeroExShell", this.selectedItem.feezeroExShell);
            if (
              this.selectedItem.cryptoactive != null &&
              this.selectedItem.cryptoactive.bool
            ) {
              data.append("feeDp", this.selectedItem.feeDp);
              data.append(
                "currencyDp",
                typeof this.selectedItem.currencyDp == "boolean"
                  ? this.selectedItem.currencyDp
                  : this.selectedItem.currencyDp.bool
              );
              data.append(
                "typeFeeDp",
                typeof this.selectedItem.typeFeeDp == "boolean"
                  ? this.selectedItem.typeFeeDp
                  : this.selectedItem.typeFeeDp.bool
              );
            //  data.append("feezeroDp", this.selectedItem.feezeroDp);

              data.append("feeSk", this.selectedItem.feeSk);
              data.append(
                "currencySk",
                typeof this.selectedItem.currencySk == "boolean"
                  ? this.selectedItem.currencySk
                  : this.selectedItem.currencySk.bool
              );
              data.append(
                "typeFeeSk",
                typeof this.selectedItem.typeFeeSk == "boolean"
                  ? this.selectedItem.typeFeeSk
                  : this.selectedItem.typeFeeSk.bool
              );
            //  data.append("feezeroSk", this.selectedItem.feezeroSk);
            }
            ///////////
            for (let i = 0; i < this.selectedItem.files.length; i++) {
              data.append("file" + [i], this.selectedItem.files[i]);
            }
            data.append("totalFiles", this.selectedItem.files.length);

            Api.post("actives", data, {
              header: {
                "Content-Type": "multipart/form-data",
              },
            })
              .then(() => {
                this.showSnackbar({
                  text: "Cadastrado! Ativo cadastrado com sucesso.",
                  color: "success",
                });

                this.isLoading = false;
                this.closeDialog();
              })
              .catch(() => {
                this.showSnackbar({
                  text: "Ops! Houve um erro, tente novamente.",
                  color: "error",
                });

                this.isLoading = false;
              });
          });
        } else {
          for (let i = 0; this.selectedData.arrayDuplicate.length; i++) {
            let data = new FormData();

            data.append("nameToken", this.selectedItem.nameToken);
            data.append("description", this.selectedItem.description);
            data.append(
              "category",
              this.selectedItem.category[i].id || this.selectedItem.category[i]
            );
            data.append("photo", this.selectedItem.photo);
            data.append("minValueToken", this.selectedItem.minValueToken);
            data.append("totalValueToken", this.selectedItem.totalValueToken);
            data.append("amountToken", this.selectedItem.amountToken);
            data.append("otherUnid", this.selectedItem.otherUnid);
            data.append("complement", this.selectedItem.complement);
            data.append("checkbox", this.checkbox);
            data.append("unidades", this.selectedItem.unidades.unid);
            data.append("valorunidade", this.selectedItem.valorunidade);
            data.append("subcategories", JSON.stringify(this.selectedItem.subcategories.map((el) => el.id)));
            data.append(
              "cryptoactive",
              typeof this.selectedItem.cryptoactive == "boolean"
                ? this.selectedItem.cryptoactive
                : this.selectedItem.cryptoactive.bool
            );
            data.append(
              "certificate",
              typeof this.selectedItem.certificate == "boolean"
                ? this.selectedItem.certificate
                : this.selectedItem.certificate.bool
            );
            data.append("deadlineToken", this.selectedItem.deadlineToken);
            data.append("singleValue", this.selectedItem.singleValue);
            data.append("typeValue", this.selectedItem.valueType);
            for (let i = 0; i < this.selectedItem.files.length; i++) {
              data.append("file" + [i], this.selectedItem.files[i]);
            }
            data.append("totalFiles", this.selectedItem.files.length);
            data.append("newLogoToken", this.newLogoToken);
            data.append("filesDelete", this.filesDelete);
            data.append("totalFilesDelete", this.filesDelete.length);

            //Fee
            data.append("feeMk", this.selectedItem.feeMk);
            data.append(
              "currencyMk",
              typeof this.selectedItem.currencyMk == "boolean"
                ? this.selectedItem.currencyMk
                : this.selectedItem.currencyMk.bool
            );
            data.append(
              "typeFeeMk",
              typeof this.selectedItem.typeFeeMk == "boolean"
                ? this.selectedItem.typeFeeMk
                : this.selectedItem.typeFeeMk.bool
            );
            data.append("feezeroMk", this.selectedItem.feezeroMk);

            data.append("feeTx", this.selectedItem.feeTx);
            data.append(
              "currencyTx",
              typeof this.selectedItem.currencyTx == "boolean"
                ? this.selectedItem.currencyTx
                : this.selectedItem.currencyTx.bool
            );
            data.append(
              "typeFeeTx",
              typeof this.selectedItem.typeFeeTx == "boolean"
                ? this.selectedItem.typeFeeTx
                : this.selectedItem.typeFeeTx.bool
            );
          //  data.append("feezeroTx", this.selectedItem.feezeroTx);

            data.append("feeExBuy", this.selectedItem.feeExBuy);
            data.append(
              "currencyExBuy",
              typeof this.selectedItem.currencyExBuy == "boolean"
                ? this.selectedItem.currencyExBuy
                : this.selectedItem.currencyExBuy.bool
            );
            data.append(
              "typeFeeExBuy",
              typeof this.selectedItem.typeFeeExBuy == "boolean"
                ? this.selectedItem.typeFeeExBuy
                : this.selectedItem.typeFeeExBuy.bool
            );
          //  data.append("feezeroExBuy", this.selectedItem.feezeroExBuy);

            data.append("feeExShell", this.selectedItem.feeExShell);
            data.append(
              "currencyExShell",
              typeof this.selectedItem.currencyExShell == "boolean"
                ? this.selectedItem.currencyExShell
                : this.selectedItem.currencyExShell.bool
            );
            data.append(
              "typeFeeExShell",
              typeof this.selectedItem.typeFeeExShell == "boolean"
                ? this.selectedItem.typeFeeExShell
                : this.selectedItem.typeFeeExShell.bool
            );
         //   data.append("feezeroExShell", this.selectedItem.feezeroExShell);
            if (
              this.selectedItem.cryptoactive != null &&
              this.selectedItem.cryptoactive.bool
            ) {
              data.append("feeDp", this.selectedItem.feeDp);
              data.append(
                "currencyDp",
                typeof this.selectedItem.currencyDp == "boolean"
                  ? this.selectedItem.currencyDp
                  : this.selectedItem.currencyDp.bool
              );
              data.append(
                "typeFeeDp",
                typeof this.selectedItem.typeFeeDp == "boolean"
                  ? this.selectedItem.typeFeeDp
                  : this.selectedItem.typeFeeDp.bool
              );
            //  data.append("feezeroDp", this.selectedItem.feezeroDp);

              data.append("feeSk", this.selectedItem.feeSk);
              data.append(
                "currencySk",
                typeof this.selectedItem.currencySk == "boolean"
                  ? this.selectedItem.currencySk
                  : this.selectedItem.currencySk.bool
              );
              data.append(
                "typeFeeSk",
                typeof this.selectedItem.typeFeeSk == "boolean"
                  ? this.selectedItem.typeFeeSk
                  : this.selectedItem.typeFeeSk.bool
              );
              //data.append("feezeroSk", this.selectedItem.feezeroSk);
            }

            ///////////

            Api.post(
              `actives/edit/${this.selectedData.arrayDuplicate[i].code}`,
              data,
              {
                header: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
              .then(() => {
                this.showSnackbar({
                  text: "Cadastrado! Ativo cadastrado com sucesso.",
                  color: "success",
                });

                this.isLoading = false;
                this.closeDialog();
              })
              .catch(() => {
                this.filesActives.map((item) => {
                  this.selectedItem.files.map((files, index) => {
                    if (files.name === item.name) {
                      this.selectedItem.files.splice(index, 1);
                    }
                  });
                });

                this.showSnackbar({
                  text: "Ops! Houve um erro, tente novamente.",
                  color: "error",
                });

                this.isLoading = false;
              });
          }
        }
    },
  },
};
</script>
<style>
#tokens {
  padding: 0;
  margin: 0;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
  gap: 7px;
}
#tokens li {
  text-align: center;
  min-width: 30px;
  list-style: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 3px;
}
#tokens2 {
  padding: 0;
  margin: 0;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
  gap: 10px;
}
#tokens2 li {
  text-align: center;
  list-style: none;
  padding: 5px;
  padding-left: 2px;
  min-width: 35px;
}
</style>